<template>
  <div class="recharge_left">
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <h3>{{$t('riskControl.notice')}}</h3>
      </div>
      <div id="riskControlCard">
        <el-card
          class="box-card rishControl"
          shadow="hover"
          v-for="(item, index) in riskControl.data"
          :key="index"
        >
          <!-- <h4>{{ item.time }}</h4> -->
          <div class="item-title">
            <el-row style="width: 100%;">
              <el-col :span="12">
                <div style="font-weight: 600;">{{ item.create_time }}</div>
              </el-col>
              <el-col :span="12">
                <div style="justify-content: flex-end; display: flex; font-size: 13px">{{ item.time }}</div>
              </el-col>
            </el-row>
          </div>
          <p>{{ item.detail }}</p>
        </el-card>
      </div>
      <div class="changePage">
        <el-button
          type="primary"
          icon="el-icon-arrow-left"
          size="mini"
          @click="prevRisk"
          style="background: var(--baseColor); border-color: var(--baseColor);"
          >{{$t('timeBao.previous')}}</el-button
        >
        <el-button
          type="primary"
          size="mini"
          @click="nextRisk"
          style="float: right; background: var(--baseColor); border-color: var(--baseColor);"
          >{{$t('timeBao.next')}}
          <i class="el-icon-arrow-right"></i></el-button
        >
      </div>
    </el-card>
  </div>
</template>

<script>
    export default {
      name: "riskControl",
      data(){
        return{
        riskControl: {
            data: [],
            page: 1,
            num: 20
          }
        }
      },
      methods:{
        // read risk control
        readRiskControl(){
          let that = this;
          that.$http({
            url: "/app/RiskControl/user_read_risk_control",
            method: "post",
            data: {},
            transformRequest: [(data) => JSON.stringify(data)]
          })
          .then(function (res) {
            let resData = res.data;
            if (resData.status === 200){
              that.$notify.closeAll(); // remove risk notice popup
              localStorage.removeItem('risk_notice_id');
              localStorage.removeItem('risk_notice_content');
            }else {
              that.$message.error(that.$t(resData.msgId));
            }
          })
        },
        getRiskControl(){
          let that = this;
          that.$http({
            url: "/app/RiskControl/risk_control",
            method: "post",
            
            data: {
              page:that.riskControl.page,
              num:that.riskControl.num
            },
            transformRequest: [(data) => JSON.stringify(data)]
          })
          .then(function (res) {
            let resData = res.data;
            if (resData.status === 200){
              that.riskControl.data = resData.data;
            }else {
              that.$message.error(that.$t(resData.msgId));
            }
          })
        },
        prevRisk() {
          let page = this.riskControl.page;
          if (page == 1) {
            this.$message({
              message: this.$t('timeBao.alreadyFirstPage'),
              type: 'warning'
            });
          } else {
            this.riskControl.page = page - 1;
            this.getRiskControl();
            this.scrollToTop();
          }
        },
        nextRisk() {
          let page = this.riskControl.page;
          if (this.riskControl.data.length < 20) {
            this.$message({
              message: this.$t('timeBao.alreadyLastPage'),
              type: 'warning'
            });
          } else {
            this.riskControl.page = page + 1;
            this.getRiskControl();
            this.scrollToTop();
          }
        },
        scrollToTop() {
          window.scrollTo(0,0);
        }
      },
      mounted() {
        this.getRiskControl();
        this.readRiskControl();
      }
    }
</script>

<style scoped>
.rishControl h4 {
  font-size: 16px;
}
.rishControl p {
  font-size: 14px;
  color: #909399;
}
.changePage {
  margin-top: 10px;
}

.box-card {
  border-radius: 8px;
  border: none;
  background-color: #f4f4f8;
}

.box-card >>> .el-card__header {
  background-color: #ffffff;
  border-radius: 8px;
  border: none;
  margin-bottom: 20px;
}

.box-card >>> .el-card__body {
  background-color: #ffffff;
  border-radius: 8px;
  border: none;
}

#riskControlCard >>> .box-card {
  border-bottom: 1px solid #ebeef5;
  border-radius: unset;
  background-color: unset;
}

.item-title {
    display: flex;
    width: 100%;
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/riskControl.vue